export default __webpack_public_path__ + "static/media/PlanAboutToExpire.25aadb36.svg";